import { reactive } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
import { searchFields } from '@/common';
import MultipleProductSelectComp from '@/components/CustomMultipleProductSelect.vue';
export default {
  __name: 'searchBlock',
  props: {
    userList: {
      type: Array,
      default: () => []
    },
    thresholdPlanList: {
      type: Array,
      default: () => []
    },
    productList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['search'],
  setup(__props, {
    emit
  }) {
    const filter = reactive({
      taskName: '',
      planIds: [],
      dbtIdList: [],
      createUserIds: []
    });
    const onSearch = () => {
      const param = {
        taskName: filter.taskName.trim()
      };
      emit('search', param);
    };
    const onclear = () => {
      filter.taskName = '';
      filter.planIds = [];
      filter.dbtIdList = [];
      filter.createUserIds = [];
      onSearch();
    };
    return (_ctx, _cache) => {
      const _component_a_input_search = _resolveComponent("a-input-search");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_a_form, {
        layout: "horizontal",
        model: filter,
        class: "form_wrap"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_a_input_search, {
            value: filter.taskName,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => filter.taskName = $event),
            placeholder: "预警任务名称",
            onSearch: onSearch,
            onPressEnter: onSearch
          }, null, 8, ["value"])]),
          _: 1
        }), false ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 0
        }, {
          default: _withCtx(() => [_createVNode(MultipleProductSelectComp, {
            style: {
              "width": "230px"
            },
            width: "230px",
            valueField: "dbtId",
            labelField: "appName",
            value: filter.dbtIdList,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => filter.dbtIdList = $event),
            productList: __props.productList,
            showFooter: true,
            allowClear: true,
            "search-fields": _unref(searchFields),
            onOnConfirm: onSearch
          }, null, 8, ["value", "productList", "search-fields"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_a_button, {
            class: "reset-button",
            onClick: onclear
          }, {
            default: _withCtx(() => [_createTextVNode("重置")]),
            _: 1
          }), _createVNode(_component_a_button, {
            class: "search-button",
            type: "primary",
            onClick: onSearch
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]);
    };
  }
};